export default __webpack_public_path__ + "static/media/portfolio-5.d80c3569.jpg";